const { forwardRef } = require("react");

const TextInput = forwardRef(
  ({ containerClassName, className, label, message, left, ...props }, ref) => {
    return (
      <div className={containerClassName}>
        {label && (
          <label className="text-black-200 font-semibold text-sm mb-1 block">
            {label}
          </label>
        )}
        <div className="h-11 border border-white-300 w-full flex items-center rounded-sm bg-white-100 transition-colors focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-100">
          {left && <div className="ml-3 mr-1 text-black-400">{left}</div>}
          <input
            ref={ref}
            className={
              "h-full flex-1 px-3 rounded-sm focus:outline-none bg-transparent " +
              className
            }
            {...props}
          />
        </div>
        {message && (
          <span className="text-red-300 text-sm mt-1 block">{message}</span>
        )}
      </div>
    );
  }
);

export default TextInput;
